/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        /**
         * First attempt is to work this using a table, which gives us good filtering control.
         * If the datasets get unweildy we may need to migrate to a UL.
         */
        class UserGroupListWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    
                    return new UserGroupListWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    
                    UserGroupListWidgetInstanceClass.HtmlData = htmlData;
                    if (this.Instances != null && this.Instances.length > 0) {
                        
                        this.Instances.forEach(function (instance) {
                            instance.presentInstance();
                        });
                    }
                };
                
                // core.Loader.loadVersionedCSS('widgets/userGroupList/user-group-list.min.css');
                core.Loader.getVersionedHTML('widgets/userGroupList/user-group-list.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
            }
        }
        Widgets.UserGroupListWidgetTypeClass = UserGroupListWidgetTypeClass;
        class UserGroupListWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._loader = null;
                this._noRecords = null;
                this._tableBody = null;
                this._filterText = null;
                this._showOptionsSpan = null;
                this._hideOptionsSpan = null;
                this._tableOptions = null;
                this._keywordNames = [];
                this._keywordsLoaded = false;
                this._clearFilterButton = null;
                // Extended UI options
                this._multiSelect = null;
                // Modal support
                this._addDialogContent = '';
                this._globalModalDiv = null;
                this._addGroupModalOK = null;
                this._addGroupModalInput = null;
                this._addedGroupName = '';
                this._keywordsValidated = false;
                this._allGroups = [];
                this._lastSelectedGroup = null;
                this.presentInstance = () => {
                    
                    this._container.innerHTML = UserGroupListWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._loader = this._container.querySelector('.hourglass-panel');
                    this._noRecords = this._container.querySelector('#userGroupListNoRecords');
                    this._tableBody = this._container.querySelector('#userGroupListTableBody');
                    this._filterText = this._container.querySelector('#userGroupListFilter');
                    this._showOptionsSpan = this._container.querySelector('.showOptions');
                    this._hideOptionsSpan = this._container.querySelector('.hideOptions');
                    this._clearFilterButton = this._container.querySelector('.clearFilterTextField');
                    this._tableOptions = this._container.querySelector('.tableOptions');
                    // TODO: switch to core modal handling
                    this._globalModalDiv = document.querySelector('#modalPlaceholder');
                    this._addDialogContent = this._container.querySelector('#userGroupCommentModalContent').innerHTML;
                    this._widgets.setTitle(this._config, this._container.querySelector('#userGroupListHeading'), 'STR_WPT_USER_GROUPS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#userGroupListLoading'), 'STR_WPT_LOADING');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#userGroupListNoRecordsLabel'), 'STR_WPT_NO_USER_GROUPS');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'placeholder', 'STR_WPT_FILTERLIST');
                    this._filterText.addEventListener('keyup', this._doFilter);
                    this._showOptionsSpan.addEventListener('click', this._showOptions);
                    this._hideOptionsSpan.addEventListener('click', this._hideOptions);
                    this._clearFilterButton.addEventListener('click', this._clearFilter);
                    let config = this._config;
                    this._autoUserKeyword = null;
                    this._autoGroupKeyword = null;
                    if (config.hasOwnProperty('GroupSecurityKeyword') && config.GroupSecurityKeyword)
                        this._autoGroupKeyword = config.GroupSecurityKeyword;
                    if (config.hasOwnProperty('UserSecurityKeyword') && config.UserSecurityKeyword)
                        this._autoUserKeyword = config.UserSecurityKeyword;
                    this._type.instanceReady(this.getHandle());
                    this._core.OBHelper.LoadKeywordTypes(this._keywordTypesAvailable);
                    this._loadAllUserGroups(true);
                };
                this._callFailedHandler = (json) => {
                    
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._keywordTypesAvailable = () => {
                    this._validateKeywordTypes();
                };
                // Loads all users into the internal list, if it is currently empty or forceRefresh is true
                this._loadAllUserGroups = (forceRefresh) => {
                    
                    if ((this._allGroups.length > 0) && (!forceRefresh))
                        return;
                    // Need to specify response parameters - we just want the raw records
                    let request = {
                        PopulateUsers: false,
                        PopulateSecurityKeywords: false,
                        PopulateCustomData: false
                    };
                    this._core.Loader.genericServiceCallWithData('/SecurityAdmin.svc/rest/GetAllUserGroupRecords', JSON.stringify(request), this._allGroupsReturned, {}, this._callErrorHandler, this._callFailedHandler);
                };
                this._validateKeywordTypes = () => {
                    
                    // Skip out if not loaded yet. The callback will fire this again when they are
                    if (!this._core.OBHelper.KeywordTypesLoaded) {
                        
                        return;
                    }
                    // Do the checks
                    if (this._autoGroupKeyword && (this._core.OBHelper.KeywordTypeNames.indexOf(this._autoGroupKeyword) == -1)) {
                        this.addError(`Requested security keyword type '${this._autoGroupKeyword}' either not defined or not exposed by service layer.`);
                        this._autoGroupKeyword = null;
                    }
                    if (this._autoUserKeyword && (this._core.OBHelper.KeywordTypeNames.indexOf(this._autoUserKeyword) == -1)) {
                        this.addError(`Requested security keyword type '${this._autoUserKeyword}' either not defined or not exposed by service layer.`);
                        this._autoUserKeyword = null;
                    }
                    // This flags whether the process has occurred, not whether the keywords are actually valid
                    this._keywordsValidated = true;
                };
                this._allGroupsReturned = (response) => {
                    
                    if (response.hasOwnProperty('UserGroups') && response.UserGroups != null) {
                        this._allGroups = response.UserGroups;
                    }
                    else {
                        this._allGroups = [];
                        
                    }
                    let config = this._config;
                    if (!config.hasOwnProperty('Populate') || (config.Populate == null) || (config.Populate == true))
                        this._populateForGroupAdmin();
                };
                this._populateForGroupAdmin = () => {
                    
                    this._core.Functions.hideElement(this._loader);
                    this._tableBody.innerHTML = '';
                    // No records, no content
                    if (this._allGroups.length == 0) {
                        this._core.Functions.showElement(this._noRecords);
                        this._addedGroupName = '';
                        return;
                    }
                    // We have a list of some kind
                    this._core.Functions.hideElement(this._noRecords);
                    // May need to auto-select an added group
                    let clickCell = null;
                    for (let i = 0; i < this._allGroups.length; i++) {
                        let group = this._allGroups[i];
                        let groupId = group.Id.toString();
                        let row = this._tableBody.insertRow();
                        row.setAttribute('data-id', groupId);
                        let checkCell = row.insertCell();
                        checkCell.setAttribute('data-id', groupId);
                        checkCell.id = `checkCell_${groupId}`;
                        checkCell.classList.add('checkbox-cell');
                        if (!this._multiSelect)
                            checkCell.classList.add('hidden');
                        let nameCell = row.insertCell();
                        nameCell.classList.add('vert-align', 'addCursor');
                        nameCell.setAttribute('data-id', groupId);
                        nameCell.addEventListener('click', this._groupClicked);
                        nameCell.appendChild(document.createTextNode(group.Name));
                        if (group.Name == this._addedGroupName)
                            clickCell = nameCell;
                        let addCell = row.insertCell();
                        addCell.classList.add('add-group-cell', 'vert-align', 'addCursor');
                        let addSpan = document.createElement('span');
                        addSpan.setAttribute('data-id', groupId);
                        addSpan.classList.add('wpt-font-group_add', 'font20', 'pull-right');
                        addSpan.addEventListener('click', this._addGroupClicked);
                        addCell.appendChild(addSpan);
                        if (this._multiSelect)
                            addCell.classList.add('hidden');
                    }
                    // If we have just added a group, select it to update the UI
                    if (clickCell) {
                        let event = new MouseEvent('click');
                        clickCell.dispatchEvent(event);
                    }
                    // Tidy up
                    this._addedGroupName = '';
                };
                this._showOptions = () => {
                    
                    this._core.Functions.hideElement(this._showOptionsSpan);
                    this._core.Functions.showElement(this._hideOptionsSpan);
                    this._core.Functions.showElement(this._tableOptions);
                    this._filterText.focus();
                };
                this._hideOptions = () => {
                    
                    this._core.Functions.hideElement(this._hideOptionsSpan);
                    this._core.Functions.showElement(this._showOptionsSpan);
                    this._core.Functions.hideElement(this._tableOptions);
                    this._clearFilter();
                };
                this._clearFilter = () => {
                    
                    this._core.Functions.clearAndFocusInputElement(this._filterText);
                    this._doFilter();
                };
                this._doFilter = () => {
                    
                    let filterText = this._filterText.value.toLowerCase();
                    
                    let rowLength = this._tableBody.rows.length;
                    for (let r = 0; r < rowLength; r++) {
                        let row = this._tableBody.rows[r];
                        let cellLength = row.cells.length;
                        let filterMatched = false;
                        for (let c = 0; c < cellLength && !filterMatched; c++) {
                            let cell = row.cells[c];
                            if (cell.innerText.toLowerCase().indexOf(filterText) > -1) {
                                filterMatched = true;
                            }
                        }
                        if (filterMatched) {
                            row.style.display = "";
                        }
                        else {
                            row.style.display = "none";
                        }
                    }
                };
                // We aren't going to use all the optional configuration stuff here, as it doesn't make for a 
                // clean UI. User adds the group (with possible auto-keywords), then can select and edit members,
                // security keywords etc.
                this._addGroupClicked = (event) => {
                    
                    // Update the UI with the current members and set _lastSelectedGroup
                    this._groupClicked(event);
                    // Might have a problem
                    if ((this._autoGroupKeyword || this._autoUserKeyword) && !this._keywordsValidated) {
                        this.addError(this._core.Locale.getTranslation('STR_WPT_NO_GROUP_KEYTYPE_VALIDATION'));
                        return;
                    }
                    // Select everything we need to select
                    this._globalModalDiv.innerHTML = this._addDialogContent;
                    this._addGroupModalInput = this._globalModalDiv.querySelector('#ugaGroupNameTextbox');
                    this._addGroupModalOK = this._globalModalDiv.querySelector('#ugaAddGroupOK');
                    this._core.Helper.setElementTranslation(this._addGroupModalOK, 'STR_WPT_ADD');
                    let addGroupModalCancel = this._globalModalDiv.querySelector('#ugaAddGroupCancel');
                    this._core.Helper.setElementTranslation(addGroupModalCancel, 'STR_WPT_CANCEL');
                    this._core.Helper.setElementTranslation(this._globalModalDiv.querySelector('#ugaCommentDialogHeading'), 'STR_WPT_CREATE_USER_GROUP');
                    this._core.Helper.setElementTranslation(this._globalModalDiv.querySelector('#ugaGroupNameLabel'), 'STR_WPT_NEW_USER_GROUP_NAME');
                    // Populate the auto-keyword stuff
                    if (this._autoGroupKeyword || this._autoUserKeyword) {
                        this._core.Helper.setElementTranslation(this._globalModalDiv.querySelector('#ugaSecurityKeyCheckboxesHeading'), 'STR_WPT_APPLY_SEC_KEYS');
                        if (this._autoGroupKeyword) {
                            let lbl = this._globalModalDiv.querySelector('#ugaGroupKeyLabel');
                            let groupNameText = this._core.Locale.getTranslation('STR_WPT_LABEL_GROUP_NAME');
                            lbl.innerHTML = `${this._autoGroupKeyword} = [${groupNameText}]`;
                        }
                        else
                            this._core.Functions.hideElement(this._globalModalDiv.querySelector('#ugaGroupCheckboxDiv'));
                        if (this._autoUserKeyword) {
                            let lbl = this._globalModalDiv.querySelector('#ugaUserKeyLabel');
                            let userNameText = this._core.Locale.getTranslation('STR_WPT_LABEL_USER_NAME');
                            lbl.innerHTML = `${this._autoUserKeyword} = [${userNameText}]`;
                        }
                        else
                            this._core.Functions.hideElement(this._globalModalDiv.querySelector('#ugaUserCheckboxDiv'));
                    }
                    else
                        this._core.Functions.hideElement(this._globalModalDiv.querySelector('#ugaSecurityKeyCheckboxes'));
                    // Add listeners
                    addGroupModalCancel.addEventListener('click', this._groupAddCancel);
                    this._addGroupModalOK.addEventListener('click', this._groupAddAccept);
                    this._addGroupModalInput.addEventListener('input', this._groupAddEnableOK);
                    $(document).on('hidden.bs.modal', '#modalPlaceholder', this._groupAddModalClosed);
                    $('#modalPlaceholder').modal('show');
                };
                this._groupAddEnableOK = (event) => {
                    if (this._addGroupModalInput.value)
                        this._addGroupModalOK.disabled = false;
                    else
                        this._addGroupModalOK.disabled = true;
                };
                this._groupAddCancel = (event) => {
                    $('#modalPlaceholder').modal('hide');
                };
                this._groupAddAccept = (event) => {
                    // Need a request
                    let request = {
                        Name: this._addGroupModalInput.value,
                        TemplateGroup: this._lastSelectedGroup.Name,
                        UserNames: [],
                        SecurityKeywords: []
                    };
                    // May need to add security keys
                    if (this._autoGroupKeyword) {
                        let cb = this._globalModalDiv.querySelector('#ugaGroupKeyCheckbox');
                        if (cb.checked) {
                            let sk = {
                                KeywordTypeName: this._autoGroupKeyword,
                                KeywordOperator: 'equal',
                                KeywordValue: this._addGroupModalInput.value,
                                ValueIsUserName: false
                            };
                            request.SecurityKeywords.push(sk);
                        }
                    }
                    if (this._autoUserKeyword) {
                        let cb = this._globalModalDiv.querySelector('#ugaUserKeyCheckbox');
                        if (cb.checked) {
                            let sk = {
                                KeywordTypeName: this._autoUserKeyword,
                                KeywordOperator: 'equal',
                                KeywordValue: '',
                                ValueIsUserName: true
                            };
                            request.SecurityKeywords.push(sk);
                        }
                    }
                    this._core.Loader.genericServiceCallWithData('/SecurityAdmin.svc/rest/AddUserGroup', JSON.stringify(request), this._userGroupAdded, {}, this._callErrorHandler, this._callFailedHandler);
                    $('#modalPlaceholder').modal('hide');
                };
                this._groupAddModalClosed = (event) => {
                    this._globalModalDiv.innerHTML = "";
                };
                this._userGroupAdded = (response) => {
                    if (response.hasOwnProperty('UserGroupRecord') && response.UserGroupRecord) {
                        this._addedGroupName = response.UserGroupRecord.Name;
                        this._loadAllUserGroups(true);
                    }
                };
                this._groupClicked = (event) => {
                    
                    let config = this._config;
                    let clickedItem = event.currentTarget;
                    let groupId = Number(clickedItem.getAttribute('data-id'));
                    this._lastSelectedGroup = this._allGroups.find(group => group.Id == groupId);
                    this._tableBody.querySelectorAll('.group-selected').forEach(node => {
                        node.classList.remove('group-selected');
                    });
                    this._tableBody.querySelector(`tr[data-id="${groupId}"`).classList.add('group-selected');
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.USER_GROUP_SELECTED);
                    navEvent.ActivationID = groupId;
                    navEvent.PrimaryContext = this._lastSelectedGroup;
                    let targetLayoutName = this._currentLayout;
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                
                this._instanceSelector = config.PlaceHolder;
            }
            get AutoGroupKeyword() { return this._autoGroupKeyword; }
            set AutoGroupKeyword(value) {
                
                this._autoGroupKeyword = value;
                this._validateKeywordTypes();
            }
            get AutoUserKeyword() { return this._autoUserKeyword; }
            set AutoUserKeyword(value) {
                
                this._autoUserKeyword = value;
                this._validateKeywordTypes();
            }
        }
        UserGroupListWidgetInstanceClass.HtmlData = null;
        Widgets.UserGroupListWidgetInstanceClass = UserGroupListWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
